<p-fluid>
  @if (icon()) {
    <p-floatlabel variant="on" styleClass="text-input">
      <p-iconfield>
        <p-inputicon [class]="'pi ' + icon()" />
        @if (inputMask()) {
          <p-inputmask id="on_label" [formControl]="valueFormControl()" [class]="styleClass()" [mask]="inputMask()"></p-inputmask>
        } @else {
          <input
            pInputText
            id="on_label"
            autocomplete="off"
            [formControl]="valueFormControl()"
            [class]="styleClass()"
            [attr.maxlength]="maxLength()"
          />
        }
      </p-iconfield>
      <label for="on_label">
        {{ label() }}
        @if (isRequired) {
          <span class="required-indicator">*</span>
        }
      </label>
    </p-floatlabel>
  } @else {
    <p-floatlabel variant="on" styleClass="text-input">
      @if (inputMask()) {
        <p-inputmask id="on_label" [formControl]="valueFormControl()" [class]="styleClass()" [mask]="inputMask()"></p-inputmask>
      } @else {
        <input
          pInputText
          id="on_label"
          autocomplete="off"
          [formControl]="valueFormControl()"
          [class]="styleClass()"
          [attr.maxlength]="maxLength()"
        />
      }
      <label for="on_label">
        {{ label() }}
        @if (isRequired) {
          <span class="required-indicator">*</span>
        }
      </label>
    </p-floatlabel>
  }
</p-fluid>
